import { Progress } from 'flowbite-react';
import { useEffect, useState } from 'react';
import { Img } from 'react-image';
import { useThemeContext } from 'src/context/ThemeProvider';

import LinearProgress, { linearProgressClasses } from '@mui/material/LinearProgress';
import styled from '@emotion/styled';
import { useMediaQuery } from '@mui/material';

const BorderLinearProgress = styled(LinearProgress)(({ }) => ({
	height: 10,
	borderRadius: 5,
	[`&.${linearProgressClasses.colorPrimary}`]: {
		backgroundColor: '#e5e7eb',
	},
	[`& .${linearProgressClasses.bar}`]: {
		borderRadius: 5,
		backgroundColor: '#0063f7',
	},
}));

const CreatingPositionLoader = ({
	startingCustomText,
	midTimeCustomText,
	almostDoneCustomText,
}: {
	startingCustomText?: string;
	midTimeCustomText?: string;
	almostDoneCustomText?: string;
}) => {
	const { themeMode } = useThemeContext();
	const isMobile = useMediaQuery('(max-width:960px)');
	const [progress, setProgress] = useState(0);
	const [progressText, setProgressText] = useState(startingCustomText || 'Our AI is fetching company info...');

	useEffect(() => {
		const changeProgress = setInterval(() => {
			setProgress(prev => Math.min(95, prev + 10));
		}, 3000);

		return () => clearInterval(changeProgress);
	}, []);

	useEffect(() => {
		if (progress === 40) {
			setProgressText(midTimeCustomText || 'Our AI is generating job description...');
		} else if (progress === 80) {
			setProgressText(almostDoneCustomText || 'Our AI is calculating position level...');
		}
	}, [progress]);

	return (
		<div className="w-full !h-full min-h-screen flex flex-col justify-center items-center dark:bg-[#111E2C] [&>div[aria-label='progressbar']]:w-[90%] md:[&>div[aria-label='progressbar']]:w-[50%]">
			<Img
				src={
					themeMode === 'dark'
						? 'https://masai-website-images.s3.ap-south-1.amazonaws.com/level_Up_By_Masai_Icon_Dark_a5f53496b9.svg'
						: 'https://masai-website-images.s3.ap-south-1.amazonaws.com/level_Up_By_Masai_Icon_Dark_a5f53496b9.svg'
				}
			/>
			<div className="flex gap-2 mt-4 mb-2">
				<Img src="/assets/sparkles.svg" alt="sparkles_logo" />
				<p className="whitespace-nowrap text-[#28293D] dark:text-white">{progressText}</p>
			</div>
			<BorderLinearProgress variant="determinate" sx={{ width: isMobile ? '90%' : '50%' }} value={progress} />
		</div>
	);
};

export default CreatingPositionLoader;
